import React, { useState } from 'react';
import { Modal } from 'components/Modal/Modal';
import './POAPModal.scss';
import { CloseIcon } from 'icons/close';
import { useUser } from 'hooks/useUser';
import { claimPOAP } from 'utils/PointsAPI';
import Spinner from 'components/Spinner';
import { gtag } from 'utils/analytics';
import { useNavigate } from 'react-router-dom';
import { routes } from 'routing/routes';

type POAPModalProps = {
  onClose: () => void;
  poapImage: string;
  poapId: string;
};

export const POAPModal = ({ onClose, poapId, poapImage }: POAPModalProps) => {
  const navigate = useNavigate();
  return (
    <Modal
      onClose={onClose}
      modalId="poap-modal"
      modalHeader={
        <div className="poap-modal-header">
          <div onClick={onClose}>
            <CloseIcon />
          </div>
        </div>
      }
      modalBody={
        <ClaimPoapBody
          poapId={poapId}
          onClaim={() => {
            onClose();
            navigate(routes.duskAccount.badgeCollection());
          }}
          poapImage={poapImage}
        />
      }
    />
  );
};

type ClaimPoapProps = {
  poapId: string;
  poapImage: string;
  onClaim: () => void;
};

export const ClaimPoapBody = ({ poapId, poapImage, onClaim }: ClaimPoapProps) => {
  const [isClaiming, setIsClaiming] = useState(false);
  const { account } = useUser();

  const claim = async () => {
    if (account.dusktech?.userId) {
      setIsClaiming(true);
      await claimPOAP(account.dusktech.userId, poapId);
      gtag('event', 'poap claim');
      onClaim();
    }
  };

  return (
    <div className="poap-modal-body">
      <img src={poapImage} alt="poap" />
      <div className="poap-description">
        <h3>Your POAP is here!</h3>
        <p>This POAP is for participating in Stages 1-3 of the Gribble Eggsperience.</p>
      </div>
      {isClaiming ? (
        <Spinner color={'white'} />
      ) : (
        <button className="btn btn-primary btn-md" onClick={claim}>
          claim
        </button>
      )}
    </div>
  );
};
